import React, { useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { t, useLanguage } from "@/lib/i18n";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Subscriptions from "./Subscriptions";
import Advertisements from "./Advertisements";

export default function PlansPage() {
  useLanguage();
  const { user } = useAuth();
  const search = useLocation().search;
  const selected = new URLSearchParams(search).has("advertisement") ? "advertisements" : "subscriptions";
  const [tab, setTab] = useState(selected);
  React.useEffect(() => setTab(selected), [selected, search]);
  if (!user || user.role === "guest") return <Navigate to="/app" replace />;
  return <main className="min-h-screen bg-[#FAF7F2] p-4 sm:p-6"><div className="max-w-6xl mx-auto space-y-4">
    <Link to="/app" className="text-amber-800 underline">{t("Back to tree")}</Link>
    <h1 className="font-serif text-2xl sm:text-3xl">{t("Advertisements, Plans & Subscriptions")}</h1>
    <Tabs value={tab} onValueChange={setTab}>
      <TabsList className="grid grid-cols-2 max-w-lg w-full h-auto"><TabsTrigger value="subscriptions" className="whitespace-normal text-xs sm:text-sm">{t("Plans and subscriptions")}</TabsTrigger><TabsTrigger value="advertisements" className="whitespace-normal text-xs sm:text-sm">{t("Advertisements")}</TabsTrigger></TabsList>
      <TabsContent value="subscriptions" forceMount className="data-[state=inactive]:hidden"><Subscriptions embedded /></TabsContent>
      <TabsContent value="advertisements" forceMount className="data-[state=inactive]:hidden"><Advertisements /></TabsContent>
    </Tabs>
  </div></main>;
}
